module.exports = __webpack_public_path__ + "img/product_42.825d7ce.svg";